export const scoreColor = {
    methods: {
        scoreColor(value) {
            switch (true) {
            case 0 <= value && value <= 3 && value !== null:
                return { color: '#FF5252', risk: 'Visok' };
            case 4 <= value && value <= 7:
                return { color: '#FFC107', risk: 'Umeren' };
            case 8 <= value:
                return { color: '#1ac38d', risk: 'Neznatan' };
            default:
                return { color: 'grey', risk: 'Nepoznat' };
            }
        }
    }
}
